const breadcrumbItems = [
    {
        label: 'Admin',
        href: '/admin',
    },
    {
        label: 'Organisations',
        href: '/organisations',
    },
    {
        label: 'Visibility Groups',
    },
];

const accessLevels = [
    {
        title: 'Company Admin',
        description: 'Manage users/numbers within their own Company',
        highlight: false,
    },
    {
        title: 'Partner Admin',
        description: 'Manage Companies under the Partner',
        highlight: false,
    },
    {
        title: 'Wholesaler Admin',
        description: 'Manage Partners and Companies',
        highlight: false,
    },
    {
        title: 'Visibility Groups',
        description:
            'Control down to the user level who has access to manage your TCAP company, further driving data privacy',
        highlight: true, // This will be highlighted
    },
];

const restrictionScenarios = [
    {
        title: 'Government Security Requirements',
        description:
            'A Wholesaler providing services to a Governmental department, for which only user access within the Customer\'s own country or from specified individuals is permitted',
    },
    {
        title: 'Regulatory Compliance',
        description:
            'Legal requirements that mandate restricted access to specific user data based on geographical or organizational boundaries',
    },
    {
        title: 'Data Privacy Protection',
        description:
            'Enhanced security measures requireing compartmentalized access to sensitive company and user information',
    },
];

const implementationSteps = [
    {
        step: '1',
        title: 'Default State',
        description:
            'Visibility Groups are disabled by default across all organizations for standard operational access',
    },
    {
        step: '2',
        title: 'Wholesale Level Enablement',
        description:
            'The feature must first be enabled at the Wholesaler level through support channels',
    },
    {
        step: '3',
        title: 'Company-Specific Application',
        description:
            'Even with Wholesale enablement, the feature remains OFF for individual companies until specifically activated',
    },
    {
        step: '4',
        title: 'Granular Control',
        description:
            'Visibility restrictions are applied on a per-company basis to ensure precise access control',
    },
];

export {
    accessLevels,
    breadcrumbItems,
    implementationSteps,
    restrictionScenarios,
};
